import fetch from '@/plugin/axios'

// 渠道配置列表
export function getChannelConfigList (data) {
  return fetch({
    url: '/api/common/channel-config/list',
    method: 'Post',
    data: data
  })
}

// 新增渠道配置
export function addChannelConfig (data) {
  return fetch({
    url: '/api/common/channel-config/add',
    method: 'Post',
    data: data
  })
}

// 更新渠道配置
export function updateChannelConfig (data) {
  return fetch({
    url: '/api/common/channel-config/update',
    method: 'Post',
    data: data
  })
}

// 刷新渠道配置缓存
export function refreshChannelConfigCache () {
  return fetch({
    url: '/api/common/channel-config/refresh',
    method: 'Post'
  })
}

// 渠道状态列表
export function getChannelStatusList (data) {
  return fetch({
    url: '/api/common/channel-status/list',
    method: 'Post',
    data: data
  })
}

// 设置渠道启用状态
export function setChannelStatusEnabled (data) {
  return fetch({
    url: '/api/common/channel-status/set-enabled',
    method: 'Post',
    data: data
  })
}

// 更新渠道权重
export function updateChannelStatusWeight (data) {
  return fetch({
    url: '/api/common/channel-status/update-weight',
    method: 'Post',
    data: data
  })
}

// 更新渠道优先级
export function updateChannelStatusPriority (data) {
  return fetch({
    url: '/api/common/channel-status/update-priority',
    method: 'Post',
    data: data
  })
}

// 刷新渠道状态缓存
export function refreshChannelStatusCache () {
  return fetch({
    url: '/api/common/channel-status/refresh',
    method: 'Post'
  })
}

// 渠道任务概览
export function getChannelTaskOverview (data) {
  return fetch({
    url: '/api/common/channel-status/task-overview',
    method: 'Post',
    data: data
  })
}

// 渠道任务分页列表
export function getChannelTaskPage (data) {
  return fetch({
    url: '/api/common/channel-status/task-page',
    method: 'Post',
    data: data
  })
}

// 渠道模型价格列表
export function getChannelModelPriceList (data) {
  return fetch({
    url: '/api/common/channel-model-price/list',
    method: 'Post',
    data: data
  })
}

// 新增渠道模型价格
export function addChannelModelPrice (data) {
  return fetch({
    url: '/api/common/channel-model-price/add',
    method: 'Post',
    data: data
  })
}

// 更新渠道模型价格
export function updateChannelModelPrice (data) {
  return fetch({
    url: '/api/common/channel-model-price/update',
    method: 'Post',
    data: data
  })
}

// 刷新渠道模型价格缓存
export function refreshChannelModelPriceCache () {
  return fetch({
    url: '/api/common/channel-model-price/refresh',
    method: 'Post'
  })
}

// LLM token价格列表
export function getLlmModelPriceList (data) {
  return fetch({
    url: '/api/common/llm-model-price/list',
    method: 'Post',
    data: data
  })
}

// 新增LLM token价格
export function addLlmModelPrice (data) {
  return fetch({
    url: '/api/common/llm-model-price/add',
    method: 'Post',
    data: data
  })
}

// 更新LLM token价格
export function updateLlmModelPrice (data) {
  return fetch({
    url: '/api/common/llm-model-price/update',
    method: 'Post',
    data: data
  })
}

// 刷新LLM token价格缓存
export function refreshLlmModelPriceCache () {
  return fetch({
    url: '/api/common/llm-model-price/refresh',
    method: 'Post'
  })
}

// OpenAI中转请求流水
export function getOpenAiProxyRequestList (data) {
  return fetch({
    url: '/api/common/openai-proxy-request/list',
    method: 'Post',
    data: data
  })
}

// 生成模型目录列表
export function getGenerationModelList (data) {
  return fetch({
    url: '/api/common/generation-model/list',
    method: 'Post',
    data: data
  })
}

// 新增生成模型目录
export function addGenerationModel (data) {
  return fetch({
    url: '/api/common/generation-model/add',
    method: 'Post',
    data: data
  })
}

// 更新生成模型目录
export function updateGenerationModel (data) {
  return fetch({
    url: '/api/common/generation-model/update',
    method: 'Post',
    data: data
  })
}

// 生成模型渠道映射列表
export function getGenerationModelMappingList (data) {
  return fetch({
    url: '/api/common/generation-model-mapping/list',
    method: 'Post',
    data: data
  })
}

// 新增生成模型渠道映射
export function addGenerationModelMapping (data) {
  return fetch({
    url: '/api/common/generation-model-mapping/add',
    method: 'Post',
    data: data
  })
}

// 更新生成模型渠道映射
export function updateGenerationModelMapping (data) {
  return fetch({
    url: '/api/common/generation-model-mapping/update',
    method: 'Post',
    data: data
  })
}
